// Constants for this module.
export const MAKO_COOKIE_NAME = "mako_auth_token";
export const SESSION_COOKIE_NAME = "session_identifier";
export const PASSWORD_RESET_REQUIRED = "password_reset_required";
export const SETUP_2FA_REQUIRED = "setup_2fa_required";
export const SETUP_2FA_REQUIRED_CHECKPOINT = "setup_2fa_required_checkpoint";
export const MFA_SETTING_IS_VERIFIED = "mfa_setting_is_verified";
export const ACCOUNT_REGION = "account_region";
export const IMPERSONATING_USERNAME_COOKIE = "sendgrid-impersonating-username";
